<script lang="ts">
  import { isSubscribed } from '$utils/auth';
  import { onMount } from 'svelte';

  export let data;

  $: ({ supabase, session, subscriptionClient } = data);

  onMount(() => {
    const {
      data: { subscription }
    } = supabase.auth.onAuthStateChange((event, _session) => {
      if (
        _session?.expires_at !== session?.expires_at &&
        _session?.access_token
      ) {
        subscriptionClient?.updateAccessToken(_session?.access_token);
      }
    });

    return () => subscription.unsubscribe();
  });
</script>

<svelte:head>
  {#if $isSubscribed}
    <meta name="referrer" content="no-referrer" />
  {/if}
</svelte:head>

<slot />
